var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgScaleFilled = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 25,
    height: 25,
    fill: "currentColor",
    viewBox: "0 0 25 25",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M4.96 2.016 19.842 2v.007l4.535 7.162c0 2.381-2.045 4.321-4.555 4.321s-4.556-1.94-4.556-4.32l3.638-5.695-5.75.006v12.771L18.528 22H6.236l5.365-5.708V3.482l-5.709.007 3.598 5.68c0 2.381-2.046 4.321-4.556 4.321-2.51 0-4.556-1.94-4.556-4.32l4.576-7.163.005.009Zm14.876 2.85 1.787 2.83h-3.6l1.806-2.83h.007ZM6.734 7.697l-1.787-2.83-1.806 2.83h3.593Z",
    clipRule: "evenodd"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgScaleFilled);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/ScaleFilled.aa6a94e8bfbad6e0d7c8db83b0427c65.svg";